export default __webpack_public_path__ + "static/media/map.98b9e00b.png";